export default __webpack_public_path__ + "static/media/kickboard.02e4cd0b.svg";